import { render } from "./StatusmsgMarker.vue?vue&type=template&id=2c33c576&ts=true"
import script from "./StatusmsgMarker.vue?vue&type=script&lang=ts"
export * from "./StatusmsgMarker.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/StatusmsgMarker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c33c576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c33c576', __exports__)) {
    api.reload('2c33c576', __exports__)
  }
  
  module.hot.accept("./StatusmsgMarker.vue?vue&type=template&id=2c33c576&ts=true", () => {
    api.rerender('2c33c576', render)
  })

}


export default __exports__